import React, { useEffect, useState } from 'react';
import './styles.css';

const FlightCard = ({ flightId, clients, flight, flights }) => {
  const [previousFlightFlyers, setPreviousFlightFlyers] = useState([]);
  const [currentFlightFlyers, setCurrentFlightFlyers] = useState([]);

  useEffect(() => {
    const flightIndex = flights.findIndex((f) => f.objectId === flightId);
    const previousFlight = flights[flightIndex + 1];
    const previousFlightClients = clients.find((client) => client.flightId === previousFlight?.objectId);

    setPreviousFlightFlyers([]);
    setCurrentFlightFlyers([]);

    if (previousFlightClients && previousFlightClients.groups) {
      previousFlightClients.groups.forEach((group) => {
        group.tickets?.forEach((ticket) => {
          if (ticket.flyer1 && ticket.flyer1.objectId) {
            setPreviousFlightFlyers((prev) => [...prev, ticket.flyer1.objectId]);
          }
          if (ticket.flyer2 && ticket.flyer2.objectId) {
            setPreviousFlightFlyers((prev) => [...prev, ticket.flyer2.objectId]);
          }
        });
      });
    }

    const currentFlightClients = clients.find((client) => client.flightId === flightId);
    if (currentFlightClients && currentFlightClients.groups) {
      currentFlightClients.groups.forEach((group) => {
        group.tickets?.forEach((ticket) => {
          if (ticket.flyer1 && ticket.flyer1.objectId) {
            setCurrentFlightFlyers((prev) => [...prev, ticket.flyer1.objectId]);
          }
          if (ticket.flyer2 && ticket.flyer2.objectId) {
            setCurrentFlightFlyers((prev) => [...prev, ticket.flyer2.objectId]);
          }
        });
      });
    }
  }, [flightId, clients, flights]);

  const thisFlightClients = clients.find((client) => client.flightId === flightId);

  const hasGroups = thisFlightClients && thisFlightClients.groups && thisFlightClients.groups.length > 0;

  let totalTickets = 0;
  let flightCode = flight.flightCode;
  let maxCapacity = flight.maxCapacity;
  let status = flight.status;
  let note = flight.note || '';

  if (hasGroups) {
    totalTickets = thisFlightClients.groups.reduce((total, group) => {
      let groupTotal = group.tickets?.length || 0;

      group.tickets?.forEach((ticket) => {
        if (ticket.flyer1) groupTotal += 1;
        if (ticket.flyer2) groupTotal += 1;
      });

      return total + groupTotal;
    }, 0);
  }

  const wasInPreviousFlight = (flyer) => {
    return flyer && flyer.objectId && previousFlightFlyers.includes(flyer.objectId);
  };

  const getGroupColorClass = (groupIndex) => {
    const colorOptions = [
      'pink-section',
      'yellow-section',
      'blue-section',
      'green-section',
      'orange-section',
      'teal-section',
      'red-section',
      'purple-section',
      'navy-section',
      'lime-section',
      'brown-section',
    ];

    return colorOptions[groupIndex % colorOptions.length];
  };

  const sortedGroups = hasGroups
    ? [...thisFlightClients.groups].sort((a, b) => {
        const aHasProduct = a.tickets?.some((ticket) => ticket.boardingProductName);
        const bHasProduct = b.tickets?.some((ticket) => ticket.boardingProductName);

        if (aHasProduct && !bHasProduct) return -1;
        if (!aHasProduct && bHasProduct) return 1;
        return 0;
      })
    : [];

  let paxCount = 1;

  return (
    <div className="f-table-container">
      <div className="f-table-header">
        <div className="header-left">
          <span>{flightCode}</span>
          <span className="status-badge-flight">{status}</span>
        </div>
        <div className="header-note">
          <span className="note-display">{note || ''}</span>
        </div>
        <span>
          {totalTickets}/{maxCapacity}
        </span>
      </div>

      <div className="f_table">
        {!hasGroups
          ? ''
          : sortedGroups.map((group, groupIndex) => {
              const groupColorClass = getGroupColorClass(groupIndex);
              return (
                <React.Fragment key={groupIndex}>
                  {group.tickets?.map((ticket, ticketIndex) => (
                    <>
                      <div className={`f-row ${ticket.weight > 220 ? 'has-weight-dot' : ''}`} key={ticketIndex}>
                        <div className={`pax_no ${groupColorClass}`}>{paxCount++}</div>
                        <div className="p_name">
                          {ticket.firstName} {ticket.lastName}
                        </div>
                        <div className="p_product">{ticket.product ? ticket.product : 'FUNJ'}</div>
                        <div className={`f_altitude ${ticket.altitude ? 'blue-section' : ''}`}>{ticket.altitude}</div>
                      </div>
                      {ticket.flyer1 && (
                        <div className="f-row">
                          <div className={`pax_no ${groupColorClass}`}>{paxCount++}</div>
                          <div className={`f_name ${wasInPreviousFlight(ticket.flyer1) ? 'previous-flight' : ''}`}>
                            {ticket.flyer1.shortCode}
                          </div>
                          <div className={`f_type`}>T</div>
                          <div className={`f_altitude  ${ticket.altitude ? 'blue-section' : ''}`}>
                            {ticket.altitude}
                          </div>
                        </div>
                      )}
                      {ticket.flyer2 && (
                        <div className="f-row">
                          <div className={`pax_no ${groupColorClass}`}>{paxCount++}</div>
                          <div className={`f_name ${wasInPreviousFlight(ticket.flyer2) ? 'previous-flight' : ''}`}>
                            {ticket.flyer2.shortCode}
                          </div>
                          <div className={`f_type`}>O</div>
                          <div className={`f_altitude  ${ticket.altitude ? 'blue-section' : ''}`}>
                            {ticket.altitude}
                          </div>
                        </div>
                      )}
                    </>
                  ))}
                </React.Fragment>
              );
            })}
      </div>
    </div>
  );
};
export default FlightCard;
